/**
 * BfStreakPetals — визуализация недельного streak без цифр.
 * 7 «лепестков» — по одному на каждый день недели.
 * Заполненный = в этот день была хотя бы одна сессия чтения.
 *
 * Принимает `days`: Set / массив ISO-дат за последние 7 дней.
 * Если не передано — читает 'bf-reading-days' из localStorage.
 */
const DAY_LABELS = ['Пн', 'Вт', 'Ср', 'Чт', 'Пт', 'Сб', 'Вс'];

function iso(d) {
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, '0');
  const day = String(d.getDate()).padStart(2, '0');
  return `${y}-${m}-${day}`;
}

function readDaysFromStorage() {
  try {
    const raw = localStorage.getItem('bf-reading-days');
    if (!raw) return new Set();
    return new Set(JSON.parse(raw));
  } catch {
    return new Set();
  }
}

/**
 * markTodayAsRead — call once при входе в reader, чтобы засчитать день.
 */
export function markTodayAsRead() {
  try {
    const set = readDaysFromStorage();
    set.add(iso(new Date()));
    // храним только последние 30 дней
    const cutoff = new Date();
    cutoff.setDate(cutoff.getDate() - 30);
    const filtered = [...set].filter((d) => new Date(d) >= cutoff);
    localStorage.setItem('bf-reading-days', JSON.stringify(filtered));
  } catch {
    /* no-op */
  }
}

export default function BfStreakPetals({ days, weekStart = 'monday' }) {
  const set = days instanceof Set ? days : days ? new Set(days) : readDaysFromStorage();
  // Собираем последние 7 дней начиная от понедельника текущей недели
  const today = new Date();
  const dow = today.getDay(); // 0 = вс
  const mondayOffset = weekStart === 'monday' ? (dow === 0 ? -6 : 1 - dow) : -dow;
  const weekDates = Array.from({ length: 7 }).map((_, i) => {
    const d = new Date(today);
    d.setDate(today.getDate() + mondayOffset + i);
    return d;
  });
  const filledCount = weekDates.reduce((n, d) => n + (set.has(iso(d)) ? 1 : 0), 0);

  return (
    <div className="bf-streak" role="img" aria-label={`Прочитано ${filledCount} из 7 дней`}>
      <div className="bf-streak__row">
        {weekDates.map((d, i) => {
          const isToday = iso(d) === iso(today);
          const filled = set.has(iso(d));
          return (
            <div key={i} className="bf-streak__cell">
              <span className="bf-streak__label">{DAY_LABELS[i]}</span>
              <span
                className="bf-streak__petal"
                data-filled={filled ? 'true' : 'false'}
                data-today={isToday ? 'true' : 'false'}
                aria-hidden="true"
              />
            </div>
          );
        })}
      </div>
      <div className="bf-streak__caption">
        {filledCount === 7
          ? 'Целая неделя в Слове'
          : filledCount === 0
            ? 'Начни сегодня'
            : `${filledCount} из 7 дней`}
      </div>
    </div>
  );
}
